import { render } from "./Microsoft365Study.vue?vue&type=template&id=76e08ef0"
import script from "./Microsoft365Study.vue?vue&type=script&lang=js"
export * from "./Microsoft365Study.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__